enum ActionState {
    InProcess = 1,
    Success = 2,
    Fail = 3,
    Undefined = 4 }

export default ActionState;